var v = "5.6.3";
var fr = 30;
var ip = 0;
var op = 51;
var w = 240;
var h = 240;
var nm = "loading";
var ddd = 0;
var assets = [
	{
		id: "comp_0",
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Shape Layer 1",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.345,
									y: 0
								},
								t: 10,
								s: [
									120,
									120,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.385,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 20,
								s: [
									120,
									90.5,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.594,
									y: 0
								},
								t: 30,
								s: [
									120,
									134.5,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.167,
									y: 0
								},
								t: 40,
								s: [
									120,
									113.5,
									0
								],
								to: null,
								ti: null
							},
							{
								t: 50,
								s: [
									120,
									120,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							80,
							80,
							80
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								d: 1,
								ty: "el",
								s: {
									a: 0,
									k: [
										30,
										30
									],
									ix: 2
								},
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 3
								},
								nm: "Ellipse Path 1",
								mn: "ADBE Vector Shape - Ellipse",
								hd: false,
								_render: true
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false,
								_render: true
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false,
								_render: true
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform",
								_render: true
							}
						],
						nm: "Ellipse 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false,
						_render: true
					}
				],
				ip: 0,
				op: 61,
				st: 0,
				bm: 0,
				completed: true
			}
		]
	}
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 0,
		nm: "dot",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					159.5,
					120,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					120,
					120,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					80,
					80,
					80
				],
				ix: 6
			}
		},
		ao: 0,
		w: 240,
		h: 240,
		ip: 0,
		op: 61,
		st: 0,
		bm: 0,
		completed: true,
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Shape Layer 1",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.345,
									y: 0
								},
								t: 10,
								s: [
									120,
									120,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.385,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 20,
								s: [
									120,
									90.5,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.594,
									y: 0
								},
								t: 30,
								s: [
									120,
									134.5,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.167,
									y: 0
								},
								t: 40,
								s: [
									120,
									113.5,
									0
								],
								to: null,
								ti: null
							},
							{
								t: 50,
								s: [
									120,
									120,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							80,
							80,
							80
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								d: 1,
								ty: "el",
								s: {
									a: 0,
									k: [
										30,
										30
									],
									ix: 2
								},
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 3
								},
								nm: "Ellipse Path 1",
								mn: "ADBE Vector Shape - Ellipse",
								hd: false,
								_render: true
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false,
								_render: true
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false,
								_render: true
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform",
								_render: true
							}
						],
						nm: "Ellipse 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false,
						_render: true
					}
				],
				ip: 0,
				op: 61,
				st: 0,
				bm: 0,
				completed: true
			}
		]
	},
	{
		ddd: 0,
		ind: 2,
		ty: 0,
		nm: "dot",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					120,
					120,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					120,
					120,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					80,
					80,
					80
				],
				ix: 6
			}
		},
		ao: 0,
		w: 240,
		h: 240,
		ip: -5,
		op: 56,
		st: -5,
		bm: 0,
		completed: true,
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Shape Layer 1",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.345,
									y: 0
								},
								t: 10,
								s: [
									120,
									120,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.385,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 20,
								s: [
									120,
									90.5,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.594,
									y: 0
								},
								t: 30,
								s: [
									120,
									134.5,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.167,
									y: 0
								},
								t: 40,
								s: [
									120,
									113.5,
									0
								],
								to: null,
								ti: null
							},
							{
								t: 50,
								s: [
									120,
									120,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							80,
							80,
							80
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								d: 1,
								ty: "el",
								s: {
									a: 0,
									k: [
										30,
										30
									],
									ix: 2
								},
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 3
								},
								nm: "Ellipse Path 1",
								mn: "ADBE Vector Shape - Ellipse",
								hd: false,
								_render: true
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false,
								_render: true
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false,
								_render: true
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform",
								_render: true
							}
						],
						nm: "Ellipse 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false,
						_render: true
					}
				],
				ip: 0,
				op: 61,
				st: 0,
				bm: 0,
				completed: true
			}
		]
	},
	{
		ddd: 0,
		ind: 3,
		ty: 0,
		nm: "dot",
		refId: "comp_0",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					79.5,
					120,
					0
				],
				ix: 2
			},
			a: {
				a: 0,
				k: [
					120,
					120,
					0
				],
				ix: 1
			},
			s: {
				a: 0,
				k: [
					80,
					80,
					80
				],
				ix: 6
			}
		},
		ao: 0,
		w: 240,
		h: 240,
		ip: -10,
		op: 51,
		st: -10,
		bm: 0,
		completed: true,
		layers: [
			{
				ddd: 0,
				ind: 1,
				ty: 4,
				nm: "Shape Layer 1",
				sr: 1,
				ks: {
					o: {
						a: 0,
						k: 100,
						ix: 11
					},
					r: {
						a: 0,
						k: 0,
						ix: 10
					},
					p: {
						a: 1,
						k: [
							{
								i: {
									x: 0.667,
									y: 1
								},
								o: {
									x: 0.345,
									y: 0
								},
								t: 10,
								s: [
									120,
									120,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.385,
									y: 1
								},
								o: {
									x: 0.333,
									y: 0
								},
								t: 20,
								s: [
									120,
									90.5,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.594,
									y: 0
								},
								t: 30,
								s: [
									120,
									134.5,
									0
								],
								to: null,
								ti: null
							},
							{
								i: {
									x: 0.44,
									y: 1
								},
								o: {
									x: 0.167,
									y: 0
								},
								t: 40,
								s: [
									120,
									113.5,
									0
								],
								to: null,
								ti: null
							},
							{
								t: 50,
								s: [
									120,
									120,
									0
								]
							}
						],
						ix: 2
					},
					a: {
						a: 0,
						k: [
							0,
							0,
							0
						],
						ix: 1
					},
					s: {
						a: 0,
						k: [
							80,
							80,
							80
						],
						ix: 6
					}
				},
				ao: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								d: 1,
								ty: "el",
								s: {
									a: 0,
									k: [
										30,
										30
									],
									ix: 2
								},
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 3
								},
								nm: "Ellipse Path 1",
								mn: "ADBE Vector Shape - Ellipse",
								hd: false,
								_render: true
							},
							{
								ty: "st",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 3
								},
								o: {
									a: 0,
									k: 100,
									ix: 4
								},
								w: {
									a: 0,
									k: 0,
									ix: 5
								},
								lc: 1,
								lj: 1,
								ml: 4,
								bm: 0,
								nm: "Stroke 1",
								mn: "ADBE Vector Graphic - Stroke",
								hd: false,
								_render: true
							},
							{
								ty: "fl",
								c: {
									a: 0,
									k: [
										1,
										1,
										1,
										1
									],
									ix: 4
								},
								o: {
									a: 0,
									k: 100,
									ix: 5
								},
								r: 1,
								bm: 0,
								nm: "Fill 1",
								mn: "ADBE Vector Graphic - Fill",
								hd: false,
								_render: true
							},
							{
								ty: "tr",
								p: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 2
								},
								a: {
									a: 0,
									k: [
										0,
										0
									],
									ix: 1
								},
								s: {
									a: 0,
									k: [
										100,
										100
									],
									ix: 3
								},
								r: {
									a: 0,
									k: 0,
									ix: 6
								},
								o: {
									a: 0,
									k: 100,
									ix: 7
								},
								sk: {
									a: 0,
									k: 0,
									ix: 4
								},
								sa: {
									a: 0,
									k: 0,
									ix: 5
								},
								nm: "Transform",
								_render: true
							}
						],
						nm: "Ellipse 1",
						np: 3,
						cix: 2,
						bm: 0,
						ix: 1,
						mn: "ADBE Vector Group",
						hd: false,
						_render: true
					}
				],
				ip: 0,
				op: 61,
				st: 0,
				bm: 0,
				completed: true
			}
		]
	}
];
var markers = [
];
var __complete = true;
var EllipsisLoading = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers,
	__complete: __complete
};

export { __complete, assets, ddd, EllipsisLoading as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=ellipsis.js.map
